import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index'
import Error from '../components/error/error'
// import News from '../components/news'
// import dyindex from '../components/dyindex'
// import dyindex2 from '../components/dyindex2'
// import dyindex3 from '../components/dyindex3'
// import periodical_index from '../components/Periodical_index'

Vue.use(Router);

export default new Router({
  base:'/gdskykcsjy',
  // scrollBehavior:()=>({y:0}),
  mode:'history',
  routes: [
    // {
    // path: '/news',
    // name: 'news',
    // component: News
    // },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    // {
    //   path: '/dyindex',
    //   name: 'dyindex',
    //   component: dyindex
    // },
    // {
    //   path: '/dyindex2',
    //   name: 'dyindex2',
    //   component: dyindex2
    // },
    // {
    //   path: '/dyindex3',
    //   name: 'dyindex3',
    //   component: dyindex3
    // },
    // {
    //   path: '/gdslsd',
    //   name: 'gdslsd',
    //   component: periodical_index,
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js